import React, {FormEvent, useEffect, useState} from 'react';
import {Calendar, CalendarChangeParams} from "primereact/calendar";
import {IDateTimeProps} from "../../../utils/cellInterfaces";

export function DateTime(props: IDateTimeProps) {
    const [date, setDate] = useState<Date | undefined>(props.value ? convertStringToDate(props.value) : undefined);
    const [onCalendarFocus, setOnCalendarFocus] = useState<boolean | undefined>(undefined);

    useEffect(() => {
        if (onCalendarFocus === false && date) {
            props.changeHandler(convertDateToString(date))
        }
    }, [onCalendarFocus]);

    function convertStringToDate(value: string) {
        if (value) {
            return new Date(Date.parse(value));
        } else {
            return undefined;
        }
    }

    const formatDummyConverter = () => {
        let newFormat = '';
        if (props.format) {
            try {
                let parsedFormat = props.format.split(' ');
                newFormat = parsedFormat[0].replaceAll('yyyy', 'yy').replaceAll('MM', 'mm');
            } catch (err) {
                console.error(`Format unsupported${props.format}`);
            }
        }
        return newFormat;
    }

    const hasHours = () => {
        let has = true;
        if (props.format) {
            has = props.format.split(' ')[1] !== undefined;
        }
        return has;
    }

    const convertDateToString = (d: any): string => {
        return d.getFullYear() + "-" + ("0" + (d.getMonth() + 1)).slice(-2) + "-" + ("0" + d.getDate()).slice(-2)
            + " " + ("0" + d.getHours()).slice(-2) + ":" + ("0" + d.getMinutes()).slice(-2);
    }

    const dateChangeHandler = (e: CalendarChangeParams) => {
        if (e.value) {
            setDate(e.value as Date);
        }
    }

    const displayValue = () => {
        // if format has hours
        if (hasHours()) {
            return props.value;
        }
        return props.value.split(' ')[0];
    }

    if (props.isInEditMode) {
        return <Calendar showTime={hasHours()}
                         hourFormat="24"
                         value={date}
                         onChange={(e) => dateChangeHandler(e)}
                         dateFormat={formatDummyConverter()}
                         stepMinute={5}
                         onFocus={() => setOnCalendarFocus(true)}
                         onHide={() => setOnCalendarFocus(false)}
                         onInput={(e: FormEvent<HTMLInputElement>) => {
                             let val = e.target as HTMLInputElement;
                             if (!val.value) {
                                 setDate(undefined);
                                 props.changeHandler(undefined)
                             }
                         }}
        />
        // TODO add formatter converter
    } else {
        return <div className="p-inputtext"
                    style={{border: 'none', backgroundColor: 'transparent', color: "inherit", whiteSpace: "pre-wrap"}}>
            {
                props.value ? (displayValue().replaceAll('-', '-\u2060')) : ("N/A")
            }
        </div>
    }
}